import { DataItem } from "./panel-menu.types";

/**
 * The method returns the first found item with the given identifier
 *
 * @param arr navTree array
 * @param id Id of searched item
 * @returns DataItem
 */

export const findItem = (
  arr: DataItem[] | undefined,
  id: string
): DataItem | undefined => {
  if (!arr || arr.length === 0 || !id) {
    return undefined;
  }

  for (let i = 0; i < arr.length; i++) {
    if (arr[i].id === id) {
      return arr[i];
    } else if (arr[i].children && arr[i].children?.length) {
      const t = findItem(arr[i].children, id);

      if (t !== undefined) {
        return t;
      }
    }
  }

  return undefined;
};

/**
 * The method returns the first found active item
 *
 * @param arr navTree array
 * @returns navTree's active item
 */

export const findActiveItem = (
  arr: DataItem[] | undefined,
  searchDefaultActive: boolean = false
): DataItem | undefined => {
  if (!arr || arr.length === 0) {
    return undefined;
  }

  const activePropType = searchDefaultActive ? "defaultActive" : "isActive";

  for (let i = 0; i < arr.length; i++) {
    if (arr[i][activePropType] === true && arr[i].skipItemActivation !== true) {
      return arr[i];
    } else if (arr[i].children && arr[i].children?.length) {
      const t = findActiveItem(arr[i].children, searchDefaultActive);

      if (t !== undefined) {
        return t;
      }
    }
  }

  return undefined;
};

/**
 * The method returns all parents of the child whose ID was given
 *
 * @param arr navTree array
 * @param id child identifier
 * @returns all parents ids (array of strings)
 */

export const findParentsIds = (
  arr?: DataItem[],
  id?: string
): string[] | undefined => {
  if (!arr || arr.length === 0 || !id) {
    return undefined;
  }

  for (let i = 0; i < arr.length; i++) {
    const itemChildren = arr[i].children;
    const itemId = arr[i].id;
    if (itemId === id) {
      return [];
    } else if (itemChildren?.length && itemId) {
      const t = findParentsIds(itemChildren, id);

      if (t !== undefined) {
        t.push(itemId);

        return t;
      }
    }
  }

  return undefined;
};
